module.exports = __webpack_public_path__ + "static/img/default_cover.20f3418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/thank/default_cover.png
// module id = flCV
// module chunks = 1